class SummaryContext {
  static doctorName: string;
  static serviceNumber: number;
  static summarySequence: number;
}

export default SummaryContext;
